import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { CONFIG } from "../data";
import { Link, useNavigate } from "react-router-dom";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 768) setOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const go = (id) => {
    setOpen(false);
    navigate("/");

    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const NAV_ITEMS = ["about", "menu", "services", "gallery", "contact"];

  return (
    <>
      <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>

        {/* ✅ FIXED LOGO */}
        <div className="nav-brand" onClick={() => go("hero")}>
          <img src="/logo.png" alt="Logo" className="brand-logo" />
          <div>
            <span className="brand-name">{CONFIG.businessName}</span>
            <span className="brand-tagline">Chettinad Cuisine</span>
          </div>
        </div>

        {/* Desktop Links */}
        <ul className="nav-links-desktop">

          <li><Link to="/">Home</Link></li>

          {NAV_ITEMS.map((s) => (
            <li key={s}>
              <button onClick={() => go(s)}>
                {s.charAt(0).toUpperCase() + s.slice(1)}
              </button>
            </li>
          ))}

          <li><Link to="/catering-services-chennai">Chennai</Link></li>
          <li><Link to="/catering-services-madurai">Madurai</Link></li>
          <li><Link to="/catering-services-coimbatore">Coimbatore</Link></li>

          <li>
            <a
              href={`https://wa.me/${CONFIG.whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-book"
            >
              Book Now
            </a>
          </li>
        </ul>

        {/* Hamburger */}
        <button
          className={`hamburger ${open ? "open" : ""}`}
          onClick={() => setOpen((o) => !o)}
        >
          <span /><span /><span />
        </button>
      </nav>

      {/* Mobile Drawer */}
      <div className={`nav-drawer ${open ? "open" : ""}`}>
        <ul className="nav-drawer-links">

          <li>
            <Link to="/" onClick={() => setOpen(false)}>Home</Link>
          </li>

          {NAV_ITEMS.map((s) => (
            <li key={s}>
              <button onClick={() => go(s)}>
                {s.charAt(0).toUpperCase() + s.slice(1)}
              </button>
            </li>
          ))}

          <li><Link to="/catering-services-chennai" onClick={() => setOpen(false)}>Chennai</Link></li>
          <li><Link to="/catering-services-madurai" onClick={() => setOpen(false)}>Madurai</Link></li>
          <li><Link to="/catering-services-coimbatore" onClick={() => setOpen(false)}>Coimbatore</Link></li>

        </ul>

        <a
          href={`https://wa.me/${CONFIG.whatsappNumber}`}
          target="_blank"
          rel="noopener noreferrer"
          className="nav-book-mobile"
          onClick={() => setOpen(false)}
        >
          📲 Book Now via WhatsApp
        </a>
      </div>

      {open && <div className="nav-backdrop" onClick={() => setOpen(false)} />}
    </>
  );
}

export default Navbar;